import { render } from "./MapPageList.vue?vue&type=template&id=5940bd4c&ts=true"
import script from "./MapPageList.vue?vue&type=script&lang=ts"
export * from "./MapPageList.vue?vue&type=script&lang=ts"

import "./MapPageList.vue?vue&type=style&index=0&id=5940bd4c&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__